module.exports = __webpack_public_path__ + "img/main.fb3e247c.png";